import {Component, OnInit} from '@angular/core';
import {DeploymentsService} from "../deployments.service";
import {ActivatedRoute, Router} from "@angular/router";
import * as moment from 'moment';
import {TimezoneService} from "../timezone.service";

@Component({
    selector: 'app-data',
    templateUrl: './data.component.html',
    styleUrls: ['./data.component.scss']
})
export class DataComponent implements OnInit {

    deploymentNumber: number | null;
    missions: any = null;

    moment: any = moment;
    timezone: any = null;


    constructor(
        private deploymentsService: DeploymentsService,
        private route: ActivatedRoute,
        public router: Router,
        private timezoneService: TimezoneService) {
        this.timezone = timezoneService.timezone;

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
    }

    ngOnInit() {
        this.deploymentsService.getAllDeployments().then(response => {
            this.missions = response.sort((a, b) => b.deployment_number - a.deployment_number);
        });

        this.deploymentNumber = parseInt(this.route.snapshot.params['deploymentNumber']);
        if (isNaN(this.deploymentNumber) && this.route.firstChild) {
            this.deploymentNumber = parseInt(this.route.firstChild.snapshot.params['deploymentNumber']);
            if (isNaN(this.deploymentNumber) && this.route.firstChild.firstChild) {
                this.deploymentNumber = parseInt(this.route.firstChild.firstChild.snapshot.params['deploymentNumber']);
            }
        }
        if(!this.deploymentNumber) {
            let memDepNum = localStorage.getItem('selectedDeploymentNumber');
            if(memDepNum) {
                this.navigateTo(parseInt(memDepNum));
            }
        }
        console.debug('deployments number:', this.deploymentNumber);
    }

    navigateTo(deploymentNumber: number) {
        console.debug('current deployments number:', this.deploymentNumber);
        console.debug('new deployments number:', deploymentNumber);
        localStorage.setItem('selectedDeploymentNumber', deploymentNumber.toString());
        if (this.deploymentNumber) {
          this.router.navigateByUrl(this.router.url.replace(this.deploymentNumber.toString(), deploymentNumber.toString()));
        } else {
          this.router.navigateByUrl(this.router.url.replace('all', deploymentNumber.toString()));
        }
    }
}
